import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import swal from 'sweetalert';
import { Navigate, useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner'
import { toast } from 'react-toastify';

import shopping from "assets/images/shopping.png";
import Icon from "@mui/material/Icon";

const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

const CartSection = ({ details, showCart, showCards, handlePage, handleSummary, cartLists}) => {
   

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);

  const [quantities, setQuantities] = useState({});
  const [cartData, setCartData] = useState(details);
  const [cartList,setCartList] = useState(cartLists)
  const [dropDownData, setDropDownData] = useState({});
  const [checkoutButton, setCheckoutButton] = useState()
  const [Disable,setDisable]=useState(false)

  console.log("checkout stock",quantities)

useEffect(() => {
  const initialQuantities = {};
  cartLists?.forEach(item => {
    const type = item?.type || 'prepaid'; 
    const key = item?.tap_plan_id + type;
    initialQuantities[key] = {
      type,
      quantity: item?.cart_quantity || 0
    };

    setCheckoutButton(item?.cart_quantity);
  });
  setQuantities(initialQuantities);
}, [details]);


  const handleUpdateCart = async (planId, newQuantity,type) => {

    setLoading(true);

    const cartData = {
      retailer_id: sessionStorage.getItem('search-ID'),
      tap_plan_id: planId,
      quantity: newQuantity,
      type:type
    };

    try {
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}order-free-stock/add-to-cart`, cartData, { headers: header });
      setCheckoutButton(response.data.data.cart_count_total)
      console.log("response in hndle cart", response.data.data.cart_count_total)
      if(response.data.data.cart_count_total===0){
        setCartData("")
        setCartList([])
        showCards(false)
        showCart(false)
        setLoading(false);
       }


      handleGoToCart();

      // setLoading(false);

    } catch (error) {

      setLoading(false);

      console.error("Error updating cart:", error);
    }
  };

  const incrementQty = (planId,type) => {
     const key = planId + type;
  setQuantities(prevQuantities => {
  const currentEntry = prevQuantities[key] || { type, quantity: 0 };
  const currentQty = currentEntry?.quantity;


  if(type==="postpaid"){
    if (currentQty < 40) {
      const newQty = currentQty + 1;
      return {
        ...prevQuantities,
        [key]: { type, quantity: newQty }
      };
    }
   }else{
  if (currentQty < 30) {
    const newQty = currentQty + 1;
    handleUpdateCart(planId, newQty, type);
    return {
      ...prevQuantities,
      [key]: { type, quantity: newQty }
    };
  }
   }
  return prevQuantities;
});
  };

  const decrementQty = (planId,type) => {
    const key = planId+type

setQuantities(prevQuantities => {

  const currentEntry = prevQuantities[key] || { type, quantity: 0 };

  if (currentEntry && currentEntry?.quantity > 0 && currentEntry?.type === type) {
    const newQty = currentEntry?.quantity - 1;
    handleUpdateCart(planId, newQty, currentEntry?.type);

    return {
      ...prevQuantities,
      [key]: { ...currentEntry, quantity: newQty }
    };
  }

  return prevQuantities;
});


  };

  const removeItem = async (planId,type) => {
    setLoading(true);
      const key = planId+type

      setQuantities(prevQuantities => {

  const currentEntry = prevQuantities[key] || 0;

  if (currentEntry && currentEntry.quantity > 0 && currentEntry.type === type) {
    const newQty = 0;
    return {
      ...prevQuantities,
      [key]: { ...currentEntry, quantity: newQty }
    };
  }
  return prevQuantities;
});
    try {
      const header = await getApiHeader();
      const formData = {
        retailer_id: sessionStorage.getItem('search-ID'),
        tap_plan_id: planId,
        quantity: 0,
        type:type
      };

      console.log("formdata.retailerid" ,formData.retailer_id)
      setLoading(true);
     const response= await axios.post(`${SERVER_URL}order-free-stock/add-to-cart`, formData, { headers: header });
        if(response.status===200){
               console.log("cart count",response.data.data.cart_count_total)
               if(response.data.data.cart_count_total===0){
                setCartData("")
                setCartList([])
                showCards(false)
                showCart(false)
               }
        }
       
      handleGoToCart();
      // setLoading(false);

    } catch (error) {
      setLoading(false);
      console.error("Error removing item from cart:", error);
    }
  };

  const handleGoToCart = async () => {
    setLoading(true);
    try {
      const header = await getApiHeader();
      const response = await axios.get(`${SERVER_URL}order-free-stock/cart`, { headers: header });
      if (response.status === 200) {
        const list = [
          ...response?.data?.data?.cart_array,
          ...response?.data?.data?.postpaid_cart_array
        ]
        setCartData(response.data?.data);
        setCartList(list)
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching cart data:", error);
    }
  };




  const suggestionHandler = (tapPlanId) => {
    console.log("tapPlanId", tapPlanId);
    const availableQuantity = quantities[tapPlanId]; // Quantity of the plan for the given tapPlanId
    console.log("Plan's available quantity", availableQuantity);
  };







  const handleCheckout = async () => {
    
    const totalQuantity = Object.values(quantities).reduce((sum, qty) => sum + qty, 0); // Sum of all quantities

   
    console.log("Total quantity:", totalQuantity);
   

    setLoading(true)
    try {
      const header = await getApiHeader()
      const formData = {
        retailer_id: sessionStorage.getItem('search-ID')
      }
      const response = await axios.post(`${SERVER_URL}order-free-stock/checkout`, formData, { headers: header })
      if (response.status === 200) {

        if(response?.data?.data?.payment_status === true){
          setLoading(false);
          handlePage('payment');
        }else{
          setCartData("")
          setCartList([])
          showCards(false)
          showCart(false)
          setLoading(false)
          swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
            button: "Close"
          });


          if(response?.data?.data){
            handleSummary(response.data.data);
            handlePage('summary');
          }
          
        }

      }

    } catch (error) {
      toast.error(error.response.data.message)
      setLoading(false)

    }
  }

const getQuantity = (planId, type) => {
   const key = planId+type
  const entry = quantities[key];
  return entry && entry.type === type ? entry.quantity : 0;
};

  const handleBack=()=>{
    handlePage("home")
  }


  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#C11D6C"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}
        
        
    <div className="container cart cart-section">
  <h2 className="text-center mb-4">Confirm Order</h2>
  {cartList?.length > 0 ? (
    <>
      <div className="oc-table">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Product</th>
                <th>Unit Price</th>
                <th>Qty</th>
                <th>Subtotal</th>
                <th>Discount</th>
                <th>Net Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cartList && cartList?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <img
                      src={item.image}
                      alt={item.offerName || "Product"}
                      className="img-fluid"
                      style={{ width: '100px' }}
                    />
                    <p style={{ textAlign: "center", color: "black" }}>{item.offerName}</p>
                  </td>
                  <td>${item.full_amount}</td>
                  <td>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => decrementQty(item.tap_plan_id,item.type)}
                      disabled={getQuantity(item.tap_plan_id,item.type) === 0}
                    >
                      -
                    </button>
                    <span className="mx-2">{item.cart_quantity}</span>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => incrementQty(item.tap_plan_id,item.type)}
                      disabled={
                        item?.type === "postpaid"
                          ? getQuantity(item.tap_plan_id,item.type) >= 40
                          : item.tap_plan_id === 37
                          ? getQuantity(item.tap_plan_id,item.type) >= 40
                          : getQuantity(item.tap_plan_id,item.type) >= 10
                      }
                      
                     





                    >
                      +
                    </button>
                  </td>
                  <td>${item.sub_total}</td>
                  <td>${item.discount}</td>
                  <td>${item.net_total}</td>
                  <td>
                    <button
                      className="btn btn-danger btn-remove"
                      onClick={() => removeItem(item.tap_plan_id,item.type)}
                    >
                      Remove <i className="fa fa-times-circle"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-6 address-box">
          <h6>Billing & Delivery Address</h6>
          <p style={{ fontWeight: "600" }}>{cartData?.address}</p>
          <p style={{ fontSize: "small" }}>
            If the address details are incorrect, please contact Telsim Retailer
            Support to change the delivery address before confirming the order.
          </p>
        </div>
        <div className="col-md-6">
          <div className="d-flex justify-content-end">
            <table className="table">
              <tbody>
                <tr>
                  <td style={{ textAlign: 'left' }}>Subtotal</td>
                  <td style={{ textAlign: 'left' }}>: ${cartData?.cart_total?.sub_total}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'left' }}>Discount Applied</td>
                  <td style={{ textAlign: 'left' }}>: - ${cartData?.cart_total?.discount}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'left' }}>Wallet Credit Used</td>
                  <td style={{ textAlign: 'left' }}>: - ${cartData?.cart_total?.wallet_used}</td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: 'left',
                      fontSize: '20px',
                      fontWeight: '700',
                      color: '#333',
                    }}
                  >
                    Grand Total
                  </td>
                  <td
                    style={{
                      textAlign: 'left',
                      fontSize: '20px',
                      fontWeight: '700',
                      color: '#c11d6c',
                    }}
                  >
                    : ${cartData?.cart_total?.grand_total}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {checkoutButton > 0 && (
        <div className="d-flex justify-content-end mt-3">
          <button className="checkout checkout-btn" onClick={handleCheckout}>
            Submit Order <i className="fa fa-caret-right"></i>
          </button>
        </div>
      )}
    </>
  ) : (
    <div
      className="container cart cart-section"
      style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontFamily: '-moz-initial' }}
    >
      <img
        src={shopping}
        alt="shopping"
        style={{ width: '150px', height: '150px' }}
      />
      <p style={{ fontSize: 18, textAlign: 'center', lineHeight: 1.5, color: 'black' }}>
        Must add items to the cart before you proceed to checkout.
      </p>
      <button
        style={{
          margin: '10px',
          backgroundColor: '#e20e75',
          borderRadius: '5px',
          border: 'none',
          color: 'white',
          padding: '3px',
          fontSize: '19px',
          width: '134px',
          fontWeight: 'bolder',
        }}
        onClick={handleBack}
      >
        Go to Plans <Icon style={{ paddingTop: '2.6%' }}>arrow_forward</Icon>
      </button>
    </div>
  )}
</div>

    </>
  );
};

export default CartSection;
